import _implicitStylesheets from "./toast.css";
import _implicitScopedStylesheets from "./toast.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _axButton from "ax/button";
import _axIconInteractive from "ax/iconInteractive";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3${3}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<br${3}>`;
const stc0 = {
  "ax-toast-icon": true
};
const stc1 = {
  key: 2
};
const stc2 = {
  key: 5
};
const stc3 = {
  "toast-close": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, t: api_text, b: api_bind, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.classes),
    key: 0
  }, [!$cmp.hideIcon ? api_custom_element("ax-icon", _axIcon, {
    slotAssignment: "start",
    classMap: stc0,
    props: {
      "iconDescription": $cmp.theme,
      "theme": $cmp.theme,
      "icon": $cmp.icon
    },
    key: 1
  }) : null, api_element("section", stc1, [api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.toastTitle))]), api_element("p", stc2, [api_text(api_dynamic_text($cmp.toastMessage)), $cmp.toastActionMessage ? $cmp.inlineAction ? api_text(" ") : null : null, $cmp.toastActionMessage ? !$cmp.inlineAction ? api_static_fragment($fragment2, 7) : null : null, $cmp.toastActionMessage ? api_custom_element("ax-button", _axButton, {
    props: {
      "variant": "text",
      "size": "small",
      "href": $cmp.toastAction,
      "ariaLabel": $cmp.ariaLabel,
      "ariaLive": $cmp.ariaLive,
      "text": $cmp.toastActionMessage
    },
    key: 8,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleToastAction))
    }
  }) : null])]), !$cmp.hideCloseAction ? api_custom_element("ax-icon-interactive", _axIconInteractive, {
    classMap: stc3,
    props: {
      "transparentBackground": "true",
      "iconDescription": "Close",
      "icon": "close",
      "ariaLabel": $cmp.closeAriaLabel,
      "ariaLive": $cmp.closeAriaLive
    },
    key: 9,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClose))
    }
  }) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4vaoo6b42dq";
tmpl.legacyStylesheetToken = "undefined-_toast";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
